module.exports = __webpack_public_path__ + "static/img/yinliang.98e1c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yinliang.png
// module id = 6HxZ
// module chunks = 24